import request from '../utils/request';
//获取我的主页用户信息
export function toPersonalCenter(data) {
  return request({
    url: '/wap/tyUser/toPersonalCenter.do',
    method: 'get',
    params: data
  });
}
//获取账户余额
export function toMyAccount(data) {
  return request({
    url: '/wap/tyUser/toMyAccount.do',
    method: 'get',
    params: data
  });
}
//个人资料
export function toPersonalData(data) {
  return request({
    url: '/wap/tyUser/toPersonalData.do',
    method: 'get',
    params: data
  });
}
//修改个人资料
export function doUpdatePerson(data) {
  return request({
    url: '/wap/tyUser/doUpdatePerson.do',
    method: 'post',
    data
  });
}
//根据分类获取地址等信息
export function toCode(data) {
  return request({
    url: '/wap/tyCode/toCode.html',
    method: 'get',
    params: data
  });
}
//根据分类获取地址等信息
export function toUserArea(data) {
  return request({
    url: '/wap/tyUser/toUserArea.html',
    method: 'get',
    params: data
  });
}
//退出登录
export function doLogout(data) {
  return request({
    url: '/wap/tyUser/doLogout.do',
    method: 'post',
    data
  });
}
export function upload(data) {
  return request({
    url: '/wab/common/upload',
    method: 'post',
    data
  });
}
//我的积分列表
export function findIntIntegralList(data) {
  return request({
    url: '/wap/tyOrder/findIntIntegralList',
    method: 'post',
    data
  });
}